var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"notFoundPage"}},[_vm._v("\n  this is not found\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }